import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjectWellsM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.48658 1.82529L4.02087 0.575928L3.55025 1.82345L0.532316 9.82345C0.434849 10.0818 0.565285 10.3703 0.823655 10.4678C1.08202 10.5652 1.37049 10.4348 1.46795 10.1764L2.10037 8.5H5.90742L6.53163 10.1746C6.62808 10.4333 6.91603 10.5649 7.17478 10.4684C7.43353 10.372 7.5651 10.084 7.46864 9.82529L4.48658 1.82529ZM5.53466 7.5L4.01527 3.42393L2.47761 7.5L5.53466 7.5Z"
        fill="#97B2C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0.5C4.27614 0.5 4.5 0.723858 4.5 1L4.5 10C4.5 10.2761 4.27614 10.5 4 10.5C3.72386 10.5 3.5 10.2761 3.5 10L3.5 1C3.5 0.723858 3.72386 0.5 4 0.5Z"
        fill="#0BA5FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0268 3.65381L15.4648 14.8154C15.5668 15.072 15.4415 15.3627 15.1849 15.4647C14.9283 15.5668 14.6375 15.4414 14.5355 15.1848L13.8656 13.5001L8.14268 13.5001L7.46399 15.1868C7.3609 15.4429 7.06966 15.567 6.81348 15.464C6.5573 15.3609 6.43319 15.0696 6.53628 14.8135L11.0268 3.65381ZM8.54507 12.5001L13.468 12.5001L12.6728 10.5001H9.34986L8.54507 12.5001ZM9.75225 9.5001H12.2752L11.0213 6.3464L9.75225 9.5001Z"
        fill="#97B2C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2.5C11.2761 2.5 11.5 2.72386 11.5 3L11.5 15C11.5 15.2761 11.2761 15.5 11 15.5C10.7239 15.5 10.5 15.2761 10.5 15L10.5 3C10.5 2.72386 10.7239 2.5 11 2.5Z"
        fill="#0BA5FF"
      />
    </svg>
  )
}
export const IconGeoObjectWells = createIcon({
  l: IconGeoObjectWellsM,
  m: IconGeoObjectWellsM,
  s: IconGeoObjectWellsM,
  xs: IconGeoObjectWellsM,
  name: 'IconGeoObjectWells',
})
